module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu4mxM.60fa3c06.60fa3c06.woff";